// userSelectors.js

export const selectDoctorList = (state) => state.doctorList.doctorList;
export const selectLoading = (state) => state.doctorList.loading;
export const selectPageCount = (state) => state.doctorList.pageCount;
export const selectBlogs = (state) => state.doctorList.blogList;
export const selectScheduleData = (state) => state.doctorList.scheduleData;




